/**
 * Under-search clearable category chip (D21 / AC-05) — single clear SSOT for platformCategory.
 */

import { useTranslation } from 'react-i18next';
import { CUSTOMER_MIN_TOUCH_TARGET_CLASS } from '../../shared/ui/customerTouchTarget.js';

export type BrowseActiveCategoryChipProps = {
  readonly label: string;
  readonly onClear: () => void;
  readonly className?: string;
};

export function BrowseActiveCategoryChip(
  props: BrowseActiveCategoryChipProps,
): JSX.Element {
  const { label, onClear, className } = props;
  const { t } = useTranslation('customer');

  return (
    <div
      className={['mt-2 flex flex-wrap items-center gap-2', className]
        .filter(Boolean)
        .join(' ')}
      data-testid="customer-browse-active-category-chip"
    >
      <span
        className={[
          'inline-flex max-w-full items-center gap-1 rounded-full border border-[var(--color-border)]',
          'bg-[var(--color-surface-muted)] pl-3 text-sm text-[var(--color-on-surface)]',
        ].join(' ')}
      >
        <span className="min-w-0 truncate">{label}</span>
        <button
          type="button"
          className={[
            'inline-flex shrink-0 items-center justify-center rounded-full px-2 text-[var(--color-accent)]',
            CUSTOMER_MIN_TOUCH_TARGET_CLASS,
            'hover:bg-[var(--color-surface-hover)]',
            'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
            'focus-visible:outline-[var(--color-focus-ring)]',
          ].join(' ')}
          aria-label={t('browse.discovery.clearCategory', {
            defaultValue: 'Zrušit kategorii',
          })}
          data-testid="customer-browse-active-category-clear"
          onClick={onClear}
        >
          ×
        </button>
      </span>
    </div>
  );
}
